/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { RichTextRenderer } from '@contember/react-client'
import clsx from 'clsx'
import NextImage from 'next/legacy/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import type { ContentReferenceImageResult } from '../../data/ContentFragment'
import style from './ImageWrapper.module.sass'
import useWindowDimensions from '../../../hooks/useWindowDimensions'

type ImageWrapperProps = {
	image: ContentReferenceImageResult
	openGallery: () => void
}

export const ImageWrapper: FunctionComponent<ImageWrapperProps> = ({ image, openGallery }) => {
	const isHorizontal = Number(image.image?.width) > Number(image.image?.height)
	const isVertical = Number(image.image?.width) < Number(image.image?.height)
	const isSquared = Number(image.image?.width) === Number(image.image?.height)

	const galleryImage = (
		<NextImage
			src={String(image.image?.url)}
			alt={image.image?.alt ?? ''}
			title={image.image?.alt}
			layout="fill"
			objectFit="contain"
		/>
	)

	const { width } = useWindowDimensions()
	const mobileWidth = Number(width) <= 768

	return (
		<div
			className={clsx(
				style.root,
				image.alignment && image.alignment === 'left' && style.alignLeft,
				image.alignment && image.alignment === 'right' && style.alignRight,
			)}
		>
			{image.image?.url && (
				<div className={style.wrapper}>
					<div
						className={clsx(
							style.wrapperInner,
							isHorizontal && style.wrapperInnerHorizontal,
							isSquared && style.wrapperInnerHorizontal,
							isVertical && style.wrapperInnerVertical,
						)}
					>
						<div
							className={clsx(
								style.imageWrapper,
								isHorizontal && style.horizontal,
								isVertical && style.vertical,
								isSquared && style.squared,
							)}
						>
							{image.link ? (
								<Link href={String(image.link)} target={image.targetBlank ? '_blank' : ''} title={image.lead}>
									{galleryImage}
								</Link>
							) : mobileWidth ? (
								galleryImage
							) : (
								<div onClick={openGallery} className={style.cursorZoom}>
									{galleryImage}
								</div>
							)}
						</div>
						{image.lead && (
							<div className={style.imageText}>
								<RichTextRenderer source={image.lead} />
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	)
}
